import { create } from 'zustand'; // Updated import

// Define the store
const useStore = create((set) => ({
  isSidenav: true, // Initial state for the sidenav
  ordersSidenav:true,
  msgcount:0,
  pendingtask:0,
  isShowMessaging:false,
  patientdata:{},
  isStreaming:true,
  // Function to toggle the sidenav state
  toggleSidenav: () => set((state) => ({ isSidenav: !state.isSidenav })),
  setIsShowMessaging:(value)=>set({isShowMessaging:value}),
  setpatientdata:(value)=>set({patientdata:value}),
  // Function to explicitly set the sidenav state
  setSidenav: (value) => set({ isSidenav: value }),
  setMessagecount: (value) => set({ msgcount: value }),
  setPendingcount: (value) => set({ pendingtask: value }),
}));

export default useStore;
